import { toast } from 'react-toastify';
import { uniqueId } from 'lodash';
import api from '../../api';
import { DocuSign, SignersToNotification } from './type';

export async function postDocumentToDocuSign(document: Partial<DocuSign>) {
  try {
    const response = await api().post('/docusign/sender', document);

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function sendNotificationRequest(data: any) {
  try {
    const response = await api().post('/sign-integration/notification', data);

    return response;
  } catch (error: any) {
    console.error('Error sendNotificationRequest => ', error);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}
